const payment = require('./Payment');
const shield = require('./Shield');
const shipping = require('./Shipping');

module.exports = {
  payment,
  shield,
  shipping,
};
